// extracted by mini-css-extract-plugin
export default {"imageWrapper":"qG-z","twoColumnImage":"rG-z"};